module.exports = __webpack_public_path__ + "static/organik_buyume_01-dacbb1bbedd3016e677f6186efdbc1e3.webp";